import React, { useState, useEffect } from "react";
import {
  ExclamationTriangleIcon,
  ComputerDesktopIcon,
  PlayIcon,
  ArrowsPointingOutIcon,
} from "@heroicons/react/24/outline";
import {
  ExclamationTriangleIcon as ExclamationTriangleIconSolid,
  ComputerDesktopIcon as ComputerDesktopIconSolid,
} from "@heroicons/react/24/solid";
const ExamModals = ({
  showFullscreenModal,
  shouldPromptFullscreen,
  setShouldPromptFullscreen,
  handleBackToFullscreen,
}) => {
  const [isFullscreenVisible, setIsFullscreenVisible] = useState(false);
  const [isPromptVisible, setIsPromptVisible] = useState(false);

  useEffect(() => {
    if (showFullscreenModal) {
      setIsFullscreenVisible(true);
    } else {
      const timer = setTimeout(() => {
        setIsFullscreenVisible(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [showFullscreenModal]);

  useEffect(() => {
    if (shouldPromptFullscreen) {
      setIsPromptVisible(true);
    } else {
      const timer = setTimeout(() => {
        setIsPromptVisible(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [shouldPromptFullscreen]);

  const handleStartFullscreen = () => {
    const el = document.documentElement;
    if (el.requestFullscreen) el.requestFullscreen();
    else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
    else if (el.mozRequestFullScreen) el.mozRequestFullScreen();
    else if (el.msRequestFullscreen) el.msRequestFullscreen();

    setShouldPromptFullscreen(false);
  };

  return (
    <>
      {/* Modal cảnh báo khi thoát fullscreen - Modern Design */}
      {(showFullscreenModal || isFullscreenVisible) && (
        <>
          {/* Backdrop with modern blur effect */}
          <div
            className={`fixed inset-0 bg-gradient-to-br from-red-900/90 via-orange-900/60 to-yellow-900/70 backdrop-blur-lg z-[9999] transition-all duration-500 ${
              isFullscreenVisible ? "opacity-100" : "opacity-0"
            }`}
          />

          {/* Modal Container */}
          <div
            className={`fixed inset-0 z-[10000] flex items-center justify-center p-4 transition-all duration-500 ${
              isFullscreenVisible
                ? "opacity-100 scale-100"
                : "opacity-0 scale-90"
            }`}
          >
            <div className="relative w-full max-w-lg bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 overflow-hidden transform transition-all duration-500">
              {/* Animated Background Elements */}
              <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-20 -right-20 w-40 h-40 bg-gradient-to-br from-red-400/20 to-orange-600/20 rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-gradient-to-br from-yellow-400/20 to-red-600/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
              </div>

              {/* Header Section */}
              <div className="relative px-8 pt-12 pb-6 text-center">
                {/* Warning Icon */}
                <div className="relative inline-flex items-center justify-center mb-6">
                  <div className="w-20 h-20 rounded-full bg-gradient-to-br from-red-500 to-orange-600 flex items-center justify-center shadow-2xl animate-pulse">
                    <ExclamationTriangleIconSolid className="w-10 h-10 text-white" />
                  </div>
                  {/* Floating rings */}
                  <div className="absolute inset-0 rounded-full border-4 border-red-300/30 animate-ping"></div>
                  <div className="absolute inset-0 rounded-full border-2 border-orange-400/50 animate-pulse delay-500"></div>
                </div>

                <h2 className="text-2xl font-bold bg-gradient-to-r from-red-700 to-orange-600 bg-clip-text text-transparent mb-2">
                  Thoát khỏi toàn màn hình!
                </h2>
                <p className="text-gray-600 text-sm mb-6">
                  Bạn cần quay lại chế độ toàn màn hình để tiếp tục làm bài thi
                </p>
              </div>

              {/* Content Section */}
              <div className="px-8 pb-6">
                {/* Info Card */}
                {/* <div className="bg-gradient-to-r from-red-50 to-orange-50 border border-red-200 rounded-2xl p-4 mb-4">
                  <div className="flex items-start">
                    <ExclamationTriangleIcon className="w-5 h-5 text-red-600 mr-3 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="text-sm font-medium text-red-800 mb-1">
                        Lưu ý quan trọng
                      </p>
                      <p className="text-xs text-red-700 leading-relaxed">
                        Để đảm bảo tính bảo mật và công bằng của bài thi, bạn
                        cần duy trì chế độ toàn màn hình trong suốt quá trình
                        làm bài.
                      </p>
                    </div>
                  </div>
                </div> */}

                {/* Warning Card - Auto Submit */}
                <div className="bg-gradient-to-r from-red-100 to-orange-100 border-2 border-red-400 rounded-2xl p-4 mb-6 animate-pulse">
                  <div className="flex items-start">
                    <ExclamationTriangleIconSolid className="w-6 h-6 text-red-700 mr-3 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="text-sm font-bold text-red-900 mb-2">
                        ⚠️ CẢNH BÁO TỰ ĐỘNG NỘP BÀI
                      </p>
                      <p className="text-xs text-red-800 leading-relaxed font-medium">
                        Nếu bạn thoát khỏi toàn màn hình quá{" "}
                        <span className="font-bold text-red-900">10 giây</span>,
                        hệ thống sẽ{" "}
                        <span className="font-bold text-red-900 underline">
                          tự động nộp bài thi
                        </span>{" "}
                        của bạn mà không cần xác nhận. Vui lòng quay lại toàn
                        màn hình ngay lập tức!
                      </p>
                    </div>
                  </div>
                </div>

                {/* Feature Card */}
                {/* <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-4 border border-blue-100 mb-6">
                  <div className="flex items-center mb-2">
                    <ComputerDesktopIconSolid className="w-5 h-5 text-blue-600 mr-2" />
                    <span className="text-sm font-medium text-blue-700">
                      Chế độ toàn màn hình
                    </span>
                  </div>
                  <div className="text-xs text-blue-600 leading-relaxed">
                    • Tập trung hoàn toàn vào bài thi
                    <br />
                    • Tránh phân tâm từ các ứng dụng khác
                    <br />• Đảm bảo tính bảo mật của bài thi
                  </div>
                </div> */}
              </div>

              {/* Action Button */}
              <div className="px-8 pb-8">
                <button
                  onClick={handleBackToFullscreen}
                  className="w-full bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white font-bold py-4 px-6 rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 flex items-center justify-center group relative overflow-hidden"
                >
                  {/* Animated background */}
                  <div className="absolute inset-0 bg-gradient-to-r from-red-400/50 to-orange-400/50 transform -skew-x-12 translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>

                  <div className="relative flex items-center">
                    <ArrowsPointingOutIcon className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform" />
                    <span>Quay lại toàn màn hình</span>
                    <PlayIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Modal prompt để bắt đầu fullscreen - Modern Design */}
      {(shouldPromptFullscreen || isPromptVisible) && (
        <>
          {/* Backdrop with modern blur effect */}
          <div
            className={`fixed inset-0 bg-gradient-to-br from-slate-900/80 via-blue-900/40 to-indigo-900/60 backdrop-blur-lg z-[9999] transition-all duration-500 ${
              isPromptVisible ? "opacity-100" : "opacity-0"
            }`}
          />

          {/* Modal Container */}
          <div
            className={`fixed inset-0 z-[10000] flex items-center justify-center p-4 transition-all duration-500 ${
              isPromptVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"
            }`}
          >
            <div className="relative w-full max-w-lg bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 overflow-hidden transform transition-all duration-500">
              {/* Animated Background Elements */}
              <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-20 -right-20 w-40 h-40 bg-gradient-to-br from-blue-400/20 to-indigo-600/20 rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-gradient-to-br from-purple-400/20 to-blue-600/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
              </div>

              {/* Header Section */}
              <div className="relative px-8 pt-12 pb-6 text-center">
                {/* Desktop Icon */}
                <div className="relative inline-flex items-center justify-center mb-6">
                  <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-2xl animate-pulse">
                    <ComputerDesktopIconSolid className="w-10 h-10 text-white" />
                  </div>
                  {/* Floating rings */}
                  <div className="absolute inset-0 rounded-full border-4 border-blue-300/30 animate-ping"></div>
                  <div className="absolute inset-0 rounded-full border-2 border-indigo-400/50 animate-pulse delay-500"></div>
                </div>

                <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-700 to-indigo-600 bg-clip-text text-transparent mb-2">
                  Bắt đầu bài kiểm tra
                </h2>
                <p className="text-gray-600 text-sm mb-6">
                  Kích hoạt chế độ toàn màn hình để bắt đầu làm bài
                </p>
              </div>

              {/* Content Section */}
              <div className="px-8 pb-6">
                {/* Requirements Card */}
                {/* <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-4 border border-blue-100 mb-4">
                  <div className="flex items-center mb-3">
                    <ComputerDesktopIcon className="w-5 h-5 text-blue-600 mr-2" />
                    <span className="text-sm font-medium text-blue-700">
                      Yêu cầu bắt buộc
                    </span>
                  </div>
                  <div className="text-xs text-blue-600 leading-relaxed space-y-1">
                    <div>• Chế độ toàn màn hình phải được duy trì</div>
                    <div>• Không được chuyển sang ứng dụng khác</div>
                    <div>• Đảm bảo môi trường thi nghiêm túc</div>
                  </div>
                </div> */}

                {/* Warning Card - Auto Submit */}
                <div className="bg-gradient-to-r from-orange-100 to-red-100 border-2 border-orange-400 rounded-2xl p-4 mb-6">
                  <div className="flex items-start">
                    <ExclamationTriangleIconSolid className="w-6 h-6 text-orange-700 mr-3 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="text-sm font-bold text-orange-900 mb-2">
                        ⚠️ LƯU Ý QUAN TRỌNG
                      </p>
                      <p className="text-xs text-orange-800 leading-relaxed font-medium">
                        Nếu bạn thoát khỏi toàn màn hình quá{" "}
                        <span className="font-bold text-orange-900">
                          10 giây
                        </span>
                        , hệ thống sẽ{" "}
                        <span className="font-bold text-orange-900 underline">
                          tự động nộp bài thi
                        </span>{" "}
                        của bạn mà không cần xác nhận. Vui lòng duy trì chế độ
                        toàn màn hình trong suốt quá trình làm bài!
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Button */}
              <div className="px-8 pb-8">
                <button
                  onClick={handleStartFullscreen}
                  className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-bold py-4 px-6 rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 flex items-center justify-center group relative overflow-hidden"
                >
                  {/* Animated background */}
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-400/50 to-indigo-400/50 transform -skew-x-12 translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>

                  <div className="relative flex items-center">
                    <PlayIcon className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform" />
                    <span>Bắt đầu toàn màn hình</span>
                    <ArrowsPointingOutIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ExamModals;
